// ═══════════════ TRAINING SERVICE ═══════════════
import { collection, doc, getDoc, getDocs, query, where, orderBy, serverTimestamp, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';

export async function getTrainingModules() {
  const q = query(collection(db, 'trainingModules'), where('active', '==', true), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function getModuleDetails(moduleId) {
  const snap = await getDoc(doc(db, 'trainingModules', moduleId));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

export async function getDriverCompletions(driverId) {
  const q = query(collection(db, 'driverTraining', driverId, 'completions'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function submitQuizAttempt(driverId, moduleId, answers) {
  const fn = httpsCallable(functions, 'submitQuizAttempt');
  return (await fn({ driverId, moduleId, answers })).data;
}
